import {
    BATCH_RESEND_SUCCESS
} from '../../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case BATCH_RESEND_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/systemControl/ResendOrdersReducer.js